<template>
  <v-layout class="mb-3">
    <v-flex v-if="hasIcon" xs2>
      <v-icon color="red darken-2">{{ item.icon }}</v-icon>
    </v-flex>
    <v-flex :xs10="hasIcon" :xs12="!hasIcon">
      
      <div v-if="item.name" class="font-weight-bold blue--text text--darken-4">
        {{ item.name }}
      </div>

      <div class="mb-0 mt-1">
        <v-btn
          v-if="item.name === 'Resume / CV'"
          color="red darken-2"
          class="white--text font-weight-bold pr-4 pl-3"
          small
          depressed
          :href="item.link"
          target="_blank"
        >
          <v-icon left small color="white">mdi-download</v-icon>
          {{ item.text }}
        </v-btn>

        <a
          v-else-if="item.link"
          class="red--text text--darken-2 text-decoration-none font-weight-medium"
          :href="item.link"
          target="_blank"
        >
          {{ item.text }}
        </a>

        <span
          v-else
          class="grey--text text--darken-3"
        >
          {{ item.text }}
        </span>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name    : 'SidebarSectionItem',
  props   : { item: { type: Object, default: () => {} } },
  computed: {
    hasIcon () {
      return !!this.item.icon
    }
  }
}
</script>

<style scoped>
</style>